import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import InputGroup from '../../../components/form-elements/input-groups/input-group';
import NumberFieldElement from '../../../components/form-elements/inputs/number-field';
import OtherMultiChoicePayOption from '../../../components/form-elements/inputs/other-multi-choice-pay-option';
import OpenPayElement from '../../../components/form-elements/inputs/open-pay';
import SaleItemElement from '../../../components/form-elements/inputs/sale-item';

const PaymentElements = {
    OPEN: {
      type: ElementConstants.PAYMENTS.OPEN,
      component: <OpenPayElement />
    },
    MULTI_CHOICE: {
        type: ElementConstants.PAYMENTS.MULTI_CHOICE,
        component: <InputGroup type={ElementConstants.PAYMENTS.MULTI_CHOICE} />
    },
    ITEM: {
        type: ElementConstants.PAYMENTS.ITEM,
        component: <SaleItemElement />
    }
}

export default PaymentElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/elements/editor/payment.js